<template>
  <!-- container -->
  <v-row no-gutters>
    <Loading />
    <!-- NavBar for mobile -->
    <v-col cols="12">
      <v-toolbar elevation="2" height="40">
        <div class="sr-flex sr-justify-center sr-items-center">
          <slot name="toolbar-items" />
        </div>

        <v-spacer></v-spacer>

        <template>
          <slot name="toolbar-help" />
        </template>
        <v-toolbar-title class="tw-flex tw-items-center">
          <v-menu v-model="showLocalesMenu" transition="slide-y-transition" offset-y >
            <template v-slot:activator="{ on, attrs }" class="tw-5">
              <v-btn v-bind="attrs" v-on="on" color="" style="background-color: inherit;">
                <v-avatar size="32">
                  <span v-if="$i18n.locale==='en'">
                    <img src="/flags/gb.png" />
                  </span>
                  <span v-if="$i18n.locale==='fr'">
                    <img src="/flags/fr.png" />
                  </span>
                </v-avatar>
                <v-icon class="tw-ml-2" small>fa fa-caret-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <!-- ------------------------ locale to FR ------------------------ -->
              <v-list-item small text @click="$i18n.locale='fr';">
                <v-list-item-icon class="mr-1">
                  <img src="/flags/fr.png" style="margin-top: 3px;"/>
                </v-list-item-icon>
                <v-list-item-content>{{ $t(`locales.fr`) }}</v-list-item-content>
              </v-list-item>
              <!-- ------------------------ locale to EN ------------------------ -->
              <v-list-item small text @click="$i18n.locale='en';">
                <v-list-item-icon class="mr-1">
                  <img src="/flags/gb.png" style="margin-top: 3px;"/>
                </v-list-item-icon>
                <v-list-item-content>{{ $t(`locales.en`) }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-title>

        <v-toolbar-title class="tw-flex tw-items-center">
          <v-menu v-model="showMenu" transition="slide-y-transition" offset-y >
            <template v-slot:activator="{ on, attrs }" class="tw-5">
              <v-btn v-bind="attrs" v-on="on" color="" style="background-color: inherit;">
                <v-avatar size="32">
                  <img
                      :alt="$store.state.auth.user.user_name"
                      :src="
                      $store.state.auth.user.avatar
                        ? $store.state.auth.user.avatar
                        : 'https://cdn.securating.io/public/storage/shared/common/anonymous_avatar1.png'
                    "
                      class="tw-object-cover"
                  />
                </v-avatar>
                <v-icon class="tw-ml-2" small>fa fa-caret-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <!-- ------------------------ documentation ------------------------ -->
              <v-list-item v-if="isSecuratingAccount"
                  small
                  text
                  :title="$t('documentation.title')"
                  @click="clickHiddenDocumentationMenu"
              >
                <v-list-item-icon class="mr-1">
                  <v-icon small>fa-life-ring</v-icon>
                </v-list-item-icon>

                <v-list-item-content>{{ $t(`dashboard.documentation.title`) }}</v-list-item-content>
              </v-list-item>
              <!-- ------------------------ notifications ------------------------ -->
              <v-list-item small text :title="$t('account.notifications')" @click="clickHiddenNotificationMenu">
                <v-list-item-icon class="mr-1">
                  <v-icon small>fa-bell</v-icon>
                </v-list-item-icon>

                <v-list-item-content>{{ $t(`dashboard.notifications.title`) }}</v-list-item-content>
              </v-list-item>
              <!-- ------------------------ logout ------------------------ -->
              <v-list-item small text :title="$t('account.logout')" @click="logout">
                <v-list-item-icon class="mr-1">
                  <v-icon small>fa-sign-out-alt</v-icon>
                </v-list-item-icon>

                <v-list-item-content>{{ $t(`account.menu_name`) }}</v-list-item-content>
              </v-list-item>
              <!-- ------------------------ logout all ------------------------ -->
              <v-list-item small text :title="$t('account.logout_all')" @click="logoutAll">
                <v-list-item-icon class="mr-1">
                  <v-icon small>fa-fire</v-icon>
                </v-list-item-icon>

                <v-list-item-content>{{ $t(`account.logout_all`) }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-title>
      </v-toolbar>
    </v-col>
    <!-- Tab container -->
    <v-col cols="12">
      <v-container>
        <slot name="container" />
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import { Types as TypesApplication } from "@/store/modules/application"
import Loading from "@/components/common/template/Loading"
import { Types } from "@/store/modules/auth"

export default {
  components: {
    Loading,
  },
  name: "Tab",
  props: {
    noHelp: { type: Boolean, default: false },
  },
  data: () => ({
    showMenu: false,
    showLocalesMenu: false,
  }),
  computed: {
    isSecuratingAccount() {
      return this.$store.state.auth.user["doc"] === true
    },
    help() {
      return this.$store.state.application.helpIsVisible
    },
  },
  methods: {
    removeCurrent() {
      this.$emit("close")
    },
    showHelp() {
      this.$store.dispatch(TypesApplication.actions.UPDATE_HELP_VISIBILITY, true)
    },
    hideHelp() {
      this.$store.dispatch(TypesApplication.actions.UPDATE_HELP_VISIBILITY, false)
    },
    logout() {
      this.$store.dispatch(Types.actions.AUTH_LOGOUT).then(() => {
        this.$router.go(0)
      })
    },
    logoutAll() {
      this.$axios.get("office/common/logout/all").then(() => {
        this.logout()
      })
    },
    clickHiddenNotificationMenu() {
      document.getElementById("notification_menu").click()
    },
    clickHiddenDocumentationMenu() {
      document.getElementById("documentation_menu").click()
    },
  },
}
</script>
